export default __webpack_public_path__ + "static/media/GitHub.64750bf3.jpg";